import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './components/About';
import Portfolio from './components/Portfolio';
import HowWeBuild from './components/HowWeBuild';
import Contact from './components/Contact';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-[#07113a] text-[#e2e8f0] selection:bg-[#3b82f6]/30 selection-highlight">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/how-we-build" element={<HowWeBuild />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;